import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "../TitleHeader.vue";
import ResourceCards from "../resources/ResourceCards.vue";
import UserBookingTable from "../tables/UserBookingsTable.vue";

import api from "../../api/api";
import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionalDashboard',
  setup(__props) {

const { user } = storeToRefs(useUserStore());
const role = userHasRole(user.value.roles, ["professional"]) ? "professional" : "paid-professional";

const resources = ref([] as any[]);

const isLoadingResources = ref(true);

async function fetchResources() {
  isLoadingResources.value = true;
  resources.value = (
    await api.resources.listResources({
      role: role,
      page: 1,
    })
  ).data.resources;
  isLoadingResources.value = false;
}

fetchResources();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createVNode(UserBookingTable, { limit: 5 }),
    (!isLoadingResources.value)
      ? (_openBlock(), _createBlock(ResourceCards, {
          key: 0,
          role: _unref(user).roles[0].name,
          resources: resources.value.splice(0, 3)
        }, null, 8, ["role", "resources"]))
      : _createCommentVNode("", true)
  ]))
}
}

})